/* allowedCareSitesThunk.ts */

/* Redux-Toolkit */
import { createAsyncThunk } from "@reduxjs/toolkit";

/* Axios */
import axiosInterceptor from "src/utils/helper/axios-interceptor";

export const fetchAllowedCareSites = createAsyncThunk(
  "auth/allowedCareSites",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInterceptor.get<unknown>(
        "/options/care_site_names"
      );

      if (
        !Array.isArray(response.data) ||
        response.data.some((site) => typeof site !== "string")
      ) {
        return rejectWithValue("Invalid care site response shape");
      }

      return response.data as string[];
    } catch (error) {
      console.error(error);
      return rejectWithValue(
        error instanceof Error
          ? error.message
          : "Failed to load care site permissions"
      );
    }
  }
);
